const storyImage4  = 'https://drive.google.com/uc?id=1DI13D-c6L1u4dnEU4CP8AxqNpoK2SskP';
const storyImage3  = 'https://drive.google.com/uc?id=1-4RMU4pSeYsITamAeiNcnGI8zv8jYH8f';
const storyImage2  = 'https://drive.google.com/uc?id=1IY7BbW7kyoFk56sVKsfpWOmCBNPxT_YS';
const storyImage1  = 'https://drive.google.com/uc?id=1-H8v7UEuapT5o4DlQdmHpTdZ3VfIFqsw';
const successStoriesBg  = 'https://drive.google.com/uc?id=12wG8uummbY4RUBNo4Miv0bITIKj1U1Jv';

export {
    storyImage1, storyImage2, storyImage3, storyImage4,
    successStoriesBg,
};